// extracted by mini-css-extract-plugin
export default {"CTA-Container":"CTA_CTA-Container__8Rp1H","btn-nom":"CTA_btn-nom__JTMUV","nom-one-button":"CTA_nom-one-button__CQVrY","btn-mail":"CTA_btn-mail__+c2me"};